import React, { useState, memo, useEffect } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BasicAutoSelect = ({ data, onChange }) => {
    return (
        <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={data}
            disableClearable
            
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderOption={(option, { selected }) => (
                <React.Fragment>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option.title}
                </React.Fragment>
            )}
            /*style={{ width: 500 }}*/
            style={{ marginRight:"10px" }}
            renderInput={(params) => (
                <TextField {...params} variant="outlined" placeholder="Select..." />
            )}
            onChange={(e, v) => onChange(v)}
            getOptionSelected={(option, value) => option.name === value.name}
        />
    );
}


export default BasicAutoSelect;